import React, { useEffect, useState } from "react";
import _ from "lodash";
import get from "lodash/get";

import set from "@rill/set";

import SettingsNav from "../../../parts/settings-nav";
import UnitInput from "../../../parts/inputs/unit-input";
import AvatarInput from "../../../parts/inputs/avatar-input";
import { getUserToRequest } from "./manage-coaches/utils/manage-coaches-utils";
import ChangeEmailModal from "./change-email";
import ChangePasswordModal from "./change-password";
import ThemeSelector from "./branding/ThemeSelector";
import { setAppliedMode } from "../../../utils/theme-helpers";
import submit from "submit-form";
import { SettingsBackHandler } from "../../coaching-portal/settings/components/SettingsBackHandler";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

function View(props, { locals }) {
  const {
    activeUser,
    countries: countryOptions,
    momentTZ,
    organizationOwner,
  } = locals;
  const userToRequest = getUserToRequest(activeUser, organizationOwner);
  const isFe = Boolean(userToRequest.pushAccountInfo);
  const isCoach = activeUser.permissions.includes("coach");
  const activeUserName = get(activeUser, "name", "").split(/ +/);
  let renderAvatarComponent;
  const [userNameState, setUserNameState] = useState({
    first_name: activeUserName[0],
    last_name: activeUserName[1],
  });

  const { first_name, last_name } = userNameState;

  if (process.browser) {
    const userAgent = window.navigator.userAgent.toLowerCase(),
      isiOS = RegExp("iphone|ipod|ipad").test(userAgent);

    if (isiOS) {
      renderAvatarComponent = true;
    } else {
      renderAvatarComponent = false;
    }
  }

  const handleChange = ({ target }) => {
    setUserNameState(
      Object.assign(Object.assign({}, userNameState), {
        [target.name]: target.value,
      })
    );
  };

  return (
    <main className="settings profile">
      <SettingsNav classNames={"mobile-hidden"} />
      <form
        id="form-profile"
        method="POST"
        encType="multipart/form-data"
        data-noreset
        className="settings-mobile-form"
      >
        {`${first_name} ${last_name}` !==
          `${activeUserName[0]} ${activeUserName[1]}` && (
          <input type="hidden" value={true} name="updateName" />
        )}
        <h3 className="mobile-hidden">Account Setting</h3>
        <SettingsBackHandler title={"Account Settings"} />
        <AvatarInput
          name="avatar"
          defaultValue={activeUser.avatar}
          imageSize={120}
          onlyDesktop
        />
        <AvatarInput
          name="avatar"
          defaultValue={activeUser.avatar}
          imageSize={120}
          onlyMobile
        />
        <div className="row">
          <label>
            <p className="p4">First Name</p>
            <input
              required
              type="text"
              name="first_name"
              className="text-input"
              placeholder="First name"
              value={first_name}
              onChange={handleChange}
              sz="large"
            />
          </label>

          <label>
            <p className="p4">Last Name</p>
            <input
              required
              type="text"
              name="last_name"
              className="text-input"
              placeholder="Last name"
              value={last_name}
              onChange={handleChange}
              sz="large"
            />
          </label>
        </div>
        <div className="row">
          <label>
            <p className="p4">Email</p>
            <input
              type="email"
              name="email"
              className="text-input"
              placeholder="Email"
              value={activeUser.email}
              disabled
              sz="large"
            />
            <a
              role="button"
              data-button-type="text"
              href="/actions/refresh?modal[type]=change-email"
            >
              <span>Change</span>
            </a>
          </label>
          <label>
            <p className="p4">Password</p>
            <input
              type="password"
              name="password"
              className="text-input"
              placeholder="Password"
              value="******"
              disabled
              sz="large"
            />
            <a
              role="button"
              data-button-type="text"
              href="/actions/refresh?modal[type]=change-password"
            >
              <span>Change</span>
            </a>
          </label>
        </div>
        <div className="row">
          <label>
            <p className="p4">Web theme</p>

            <ThemeSelector
              inputName="webAppTheme"
              value={locals.activeUser.webAppTheme || ""}
              onChange={(name, value) => {
                locals.theme = value;
                setAppliedMode(value);
                submit(`/actions/theme`, {
                  method: "POST",
                  body: {
                    webAppTheme: value,
                  },
                });
              }}
              selectedBorder
              label="Web App Theme"
              isStorefront
            />
          </label>
        </div>
        <button
          data-button-type="primary"
          type="submit"
          id="edit-profile-button"
        >
          Save
        </button>
      </form>
    </main>
  );
}

const Profile = (app) => {
  app
    .get("/profile", set("heading", "Edit Profile"), ({ req, res, locals }) => {
      const { query } = req;
      const modal = _.get(query, "modal", {});

      locals.modal = {
        "change-email": <ChangeEmailModal locals={locals} />,
        "change-password": <ChangePasswordModal locals={locals} />,
        "activity-feed": <ActivityDrawer />,
      }[modal.type];
      res.body = <View />;
    })
    .post(
      "/profile",
      async ({ req, locals, res, api, flash, assert, momentTZ }) => {
        const { units } = locals;
        const { body, files } = req;

        const { redirect = "back" } = body;
        assert(body.first_name, 400, "A first name is required");
        assert(body.last_name, 400, "A last name is required");

        body.name = `${body.first_name} ${body.last_name}`;

        delete body.first_name;
        delete body.last_name;
        delete body.agreeTOS;
        delete body.redirect;

        body.action = "updateUserPreferences";

        await api(`user/${locals.activeUser._id}`, {
          method: "PUT",
          body,
          files,
        });
        flash("success", "Successfully updated");

        if (redirect === "back") res.backDontScroll();
        else res.redirect(redirect);
      }
    );
};

export default Profile;
